import { createIsomorphicFn } from '@tanstack/react-start';
import { getCookie } from '@tanstack/react-start/server';
import jwt from 'jsonwebtoken';

export const getAuthorizationToken = createIsomorphicFn()
    .client(() => {
        return globalThis?.localStorage?.getItem('authorizationToken') ?? null;
    })
    .server(() => {
        const sessionToken = getCookie('AuthSession');
        if (!sessionToken) {
            return null;
        }

        // Create a new JWT token that has the same claims, but "SSR" as actor
        try {
            const decoded: any = jwt.verify(sessionToken, process.env.JWT_SECRET!, { audience: process.env.JWT_AUDIENCE, issuer: process.env.JWT_ISSUER });
            decoded['actor'] = 'SSR';
            return jwt.sign(decoded, process.env.JWT_SECRET!);
        } catch (error) {
            return null;
        }
    });
